import CardMedia from './CardMedia'
import { CardTierBadge } from './TierBadge'
import {
  CardElements,
  CardLink,
  TypeChip,
  hasMedia,
  mediaLimit,
  useCardTranslation,
  type TemplateProps,
} from './card-parts'

/** Classic plus the property's short description and a link row. */
export default function TemplateDetailed({ property, options }: TemplateProps) {
  const { _t } = useCardTranslation(options)
  const media = hasMedia(property, options)

  return (
    <div className="hr-pc-card hr-pc-card--detailed">
      <CardLink property={property} options={options} />
      <CardMedia property={property} limit={mediaLimit(options)} aspectRatio={options.imageAspectRatio} t={_t}>
        <TypeChip property={property} options={options} />
        <CardTierBadge property={property} config={options.tierRating} at="media" />
      </CardMedia>

      <div className="hr-pc-body">
        {!media ? <TypeChip property={property} options={options} /> : null}
        <CardElements property={property} options={options} template="detailed" />
      </div>
    </div>
  )
}
